@include component-spacing-and-grid;

.main-content-container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: min-content 1fr;
    grid-template-areas: 'quote quote quote quote quote quote svg svg cite cite cite cite';
    column-gap: var(--column-gap);
    row-gap: 16px;
}

:host(.has-picture) {
    .main-content-container {
        grid-template-areas:
            'quote quote quote quote quote quote svg svg picture picture picture picture'
            'quote quote quote quote quote quote svg svg cite cite cite cite';
    }
}

::slotted(blockquote) {
    @include typo-ws-copy-l;

    grid-area: quote;
    margin: 0;
}

.svg {
    color: $color-grey-05-light;
    grid-area: svg;
}

::slotted(cite) {
    @include typo-ws-h4;

    font-style: normal;
    grid-area: cite;
}

::slotted(sew-picture) {
    grid-area: picture;
}

@include mq-2 {
    :host {
        .main-content-container {
            row-gap: 32px;
            grid-template-areas:
                'svg svg quote quote quote quote quote quote quote quote quote quote'
                'svg svg cite cite cite cite cite cite cite cite cite cite';
        }
    }

    :host(.has-picture) {
        .main-content-container {
            grid-template-areas:
                'svg svg quote quote quote quote quote quote quote quote quote quote'
                'svg svg picture picture picture picture picture cite cite cite cite cite';
        }
    }
}

@include mq-1 {
    :host {
        .main-content-container {
            row-gap: 24px;
        }
    }

    :host(.has-picture) {
        .main-content-container {
            grid-template-areas:
                'svg svg quote quote quote quote quote quote quote quote quote quote'
                'svg svg picture picture picture picture picture picture picture picture picture picture'
                'svg svg cite cite cite cite cite cite cite cite cite cite';
        }
    }
}
